import Vue from 'vue'
import { api } from "../../services/Api.js"
import { modalService } from '../../services/ModalService.js'
import i18n from "../../language.js";

export function delete_news_item({ commit, state }, payload){

    // adding token
    payload.token=state.appSettings.token

    modalService.createModal(i18n.t('language.news_delete_sure')).then(
    ()=>{

      // get active school
      var school = state.user_schools.find(school => school.active === 1);

      return api
      .post(school,"delete_news_item.php",payload)
      .then( result =>{ 

        var store_key=payload.news_id+payload.feed;
       

        var item=state.news[store_key].find(item => item.id === payload.id);
        
        if(item){
          
          let index = state.news[store_key].indexOf(item);
          commit('DELETE_NEWS_ITEM', {key:store_key ,index:index});
        }
        
        Vue.$toaster.toast("language.news_delete_success");
        return result;
      })
      .catch( error => {
        alert("store: delete_news_item: "+error);
        return error;
      })

    },
    () => {} // cancel modal
    )// modal

  }